import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getEmployeeReportedHours = (
    token: string, 
    backend: string, 
    id
    ) => {
    return fetch(`${getApiUrl(backend)}employeereportedtimes/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getEmployeeReportedHours